/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { axiosInstance, decodeAtob, getJwtExpiration, isEmptyData, sendAnalyticsCustomEvent, trackMetaPixelEvent } from '../utils/helper';
import qs from 'qs';
import { useDispatch } from 'react-redux';
import { setUser } from '../store/reducers/user';
import { MOBILE, WEB, companyColors, uniqueID, GEOLOCATION_PERMISSION, apiUrlB2B } from '../utils/constants';
import { setColor } from '../store/reducers/color';

const useLogin = () => {
	const dispatch = useDispatch();

	const [isLoading, setIsLoading] = useState(false);

	const queryParams = new URLSearchParams(window.location.search);
	const token = queryParams.get('token');
	const refresh_token = queryParams.get('refresh_token');
	const company = queryParams.get('company');
	const address = queryParams.get('address');
	const url = new URL(window.location.href);
	const companyUrl = url.origin;

	const handleLogin = async (token) => {
		console.log('handleLogin');
		try {
			setIsLoading(true);
			const data = {
				unquieid: uniqueID,
				token: token,
			};

			const res = await axiosInstance.post(`customers/login`, qs.stringify(data));
			if (res.data.status === 'ok') {
				const { firstName, lastName, email, primary_phone, customerUVID, customerID, companyID, companyName, address, birthDate, googleAnalytic } = res.data.result;

				const userData = {
					firstName,
					lastName,
					email,
					primary_phone,
					customerUVID,
					customerID,
					companyID,
					companyName,
					googleAnalytic,
          birthDate,
					...address,
				};
				sendAnalyticsCustomEvent('login', { company_id: companyID, company_name: companyName });
				trackMetaPixelEvent('login', {company_id: companyID, company_name: companyName});
				dispatch(setColor(companyColors));
				dispatch(
					setUser({
						...userData,
						token: token,
						refresh_token: refresh_token,
						is_b2b: false,
						device: null,
						location_permission: GEOLOCATION_PERMISSION.PROMPT,
						permission: null,
            paymentMethod: "pina",
					}),
				);
			}
			setIsLoading(false);
		} catch (error) {
			console.log('error: ', error);
			setIsLoading(false);
		}
	};

	const handleLoginB2B = async () => {
		console.log('handleLoginB2B');
		try {
			setIsLoading(true);
			const dataCompany = decodeAtob(company);
			const parseCompany = JSON.parse(dataCompany);
			const colorCompany = (typeof parseCompany?.companyColor === 'string' ? JSON.parse(parseCompany?.companyColor) : parseCompany?.companyColor) || companyColors;

			sendAnalyticsCustomEvent('login', {
				company_id: parseCompany?.companyID,
				company_name: parseCompany?.companyName,
				customer_id: parseCompany?.customerID,
			});

			dispatch(setColor(colorCompany));

			const device = parseCompany?.customerWsId === process.env.REACT_APP_BCA_WSID_WEB ? WEB : MOBILE;
			// console.log("parseCompany?.customerWsId", parseCompany?.customerWsId);
			// console.log("process.env.REACT_APP_BCA_WSID_WEB", process.env.REACT_APP_BCA_WSID_WEB);
			// console.log("WEB", WEB);
			// console.log("MOBILE", MOBILE);

			let finalPermission = null;
			let extractedAddress = {};
			let extractedPermission = null;

			const dataAddress = decodeAtob(address);
			if (!isEmptyData(dataAddress)) {
				const parsedAddress = JSON.parse(dataAddress);
				const addressData = typeof parsedAddress === 'string' ? JSON.parse(parsedAddress) : parsedAddress;

				extractedAddress = addressData?.address || {};
				extractedPermission = addressData?.permission || null;

				const matched = extractedPermission?.find((perm) => perm.wsid === parseCompany?.customerWsId);
				finalPermission = matched?.location_permission === GEOLOCATION_PERMISSION.GRANTED ? GEOLOCATION_PERMISSION.GRANTED : GEOLOCATION_PERMISSION.PROMPT;
			} else {
				finalPermission = GEOLOCATION_PERMISSION.PROMPT;
			}

			dispatch(
				setUser({
					is_b2b: true,
					token,
					refresh_token,
					device,
					customerWsId: parseCompany?.customerWsId,
					customerID: parseCompany?.customerID,
					companyID: parseCompany?.companyID,
					companyName: parseCompany?.companyName,
					googleAnalytic: parseCompany?.googleAnalytic,
					email: parseCompany?.email,
					firstName: parseCompany?.firstName,
					lastName: parseCompany?.lastName,
					primary_phone: parseCompany?.primary_phone,
					permission: extractedPermission,
					location_permission: finalPermission,
          paymentMethod: parseCompany?.paymentMethod?.toLowerCase(),
				}),
			);
			setIsLoading(false);
		} catch (error) {
			console.log('error: ', error);
			setIsLoading(false);
		}
	};

	const handleLoginWidget = async (data) => {
    console.log('handleLoginWidget');
		try {
			const dataCompany = decodeAtob(data.company);
			const parseCompany = JSON.parse(dataCompany);
			const colorCompany = (typeof parseCompany?.companyColor === 'string' ? JSON.parse(parseCompany?.companyColor) : parseCompany?.companyColor) || companyColors;
			const address = data?.address;

			sendAnalyticsCustomEvent('login', {
				company_id: parseCompany?.companyID,
				company_name: parseCompany?.companyName,
				customer_id: parseCompany?.customerID,
			});

			dispatch(setColor(colorCompany));

			let finalPermission = null;
			let extractedAddress = {};
			let extractedPermission = null;

			const dataAddress = decodeAtob(address);
			if (!isEmptyData(dataAddress)) {
				const parsedAddress = JSON.parse(dataAddress);
				const addressData = typeof parsedAddress === 'string' ? JSON.parse(parsedAddress) : parsedAddress;

				extractedAddress = addressData?.address || {};
				extractedPermission = addressData?.permission || null;

				const matched = extractedPermission?.find((perm) => perm.wsid === parseCompany?.customerWsId);
				finalPermission = matched?.location_permission === GEOLOCATION_PERMISSION.GRANTED ? GEOLOCATION_PERMISSION.GRANTED : GEOLOCATION_PERMISSION.PROMPT;
			} else {
				finalPermission = GEOLOCATION_PERMISSION.PROMPT;
			}

			dispatch(
				setUser({
					is_b2b: true,
					token: data?.token,
					refresh_token: data?.refresh_token,
					customerID: parseCompany?.customerID,
					companyID: parseCompany?.companyID,
					companyName: parseCompany?.companyName,
					googleAnalytic: parseCompany?.googleAnalytic,
					email: parseCompany?.email,
					firstName: parseCompany?.firstName,
					lastName: parseCompany?.lastName,
					primary_phone: parseCompany?.primary_phone,
					permission: extractedPermission,
					location_permission: finalPermission,
					paymentMethod: parseCompany?.paymentMethod?.toLowerCase(),
					tokenExpiresAt: getJwtExpiration(data?.token),
				}),
			);
		} catch (error) {
			console.log(error);
			throw new Error('Failed to login');
		}
	}

	const handleLoginMandiri = async () => {
    console.log('handleLoginMandiri');
		try {
			setIsLoading(true);

			const param = queryParams.get('param');

			const res = await axiosInstance.post(`${apiUrlB2B}auth/login-widget`, { 
				companyUrl,
				param,
			});

			if(res?.data?.responseCode == 200) {
				await handleLoginWidget(res?.data?.data);
			}

			setIsLoading(false);
		} catch (error) {
			console.log(error);
			setIsLoading(false);
		}
	}

	useEffect(() => {
		if (isEmptyData(token) || isEmptyData(refresh_token)) return;

		if (isEmptyData(company)) {
			handleLogin(token); // B2C user login
		} else {
			handleLoginB2B(); // B2B user login
		}
	}, [company, token, refresh_token]);

	useEffect(() => {
		if (isEmptyData(token) || isEmptyData(refresh_token)) {
			return setIsLoading(false);
		}
	}, []);

	useEffect(() => {
        // Mandiri
        if(queryParams.has('param')){
            handleLoginMandiri();
        }
    }, []);

	return { isLoading };
};

export default useLogin;
